import { IsArray, IsEnum, IsNotEmpty, IsString } from 'class-validator';
import { Permission } from '../../../../types/constants/permission';

export class RoleForm {
  @IsString()
  @IsNotEmpty()
  name: string;

  @IsArray()
  @IsEnum(Permission, { each: true })
  permissions?: Permission[];
}
